import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "CloseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var n = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon close-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(l) {
    return t.$emit("click", l);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, r = [], a = /* @__PURE__ */ i(
  s,
  n,
  r,
  !1,
  null,
  null,
  null,
  null
);
const _ = a.exports;
export {
  _ as C
};
